import React from 'react';
import * as S from './styles';

interface ButtonLoadingDotsProps {
  /** 점 개수 (기본값: 3) */
  count?: number;
  /** 점 사이 간격 - em 단위 (기본값: 0.15) */
  gap?: number;
  /** 점 크기 - em 단위 (기본값: 0.35) */
  dotSize?: number;
  /** 애니메이션 속도 - ms 단위 (기본값: 600) */
  duration?: number;
  /** 추가 스타일 */
  style?: React.CSSProperties;
  /** 추가 클래스명 */
  className?: string;
}

/**
 * 버튼 내부에서 사용하는 로딩 점 애니메이션 컴포넌트
 *
 * - 부모의 color(currentColor)를 자동 상속
 * - 부모의 font-size에 비례하여 크기 조절 (em 단위)
 * - 버튼의 children으로 사용
 *
 * @example
 * // 기본 사용법
 * <button>
 *   로딩중 <ButtonLoadingDots />
 * </button>
 *
 * // 커스텀 설정
 * <button style={{ color: '#07d993', fontSize: '16px' }}>
 *   Processing <ButtonLoadingDots count={4} gap={0.2} dotSize={0.4} />
 * </button>
 */
const ButtonLoadingDots: React.FC<ButtonLoadingDotsProps> = ({
  count = 3,
  gap = 0.15,
  dotSize = 0.35,
  duration = 600,
  style,
  className,
}) => {
  return (
    <S.DotsContainer
      $gap={gap}
      $duration={duration}
      style={style}
      className={className}
    >
      {Array.from({ length: count }).map((_, index) => (
        <S.Dot
          key={index}
          $size={dotSize}
          $delay={index * (duration / count)}
          $duration={duration}
        />
      ))}
    </S.DotsContainer>
  );
};

export default React.memo(ButtonLoadingDots);
